module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/main-view_8f052ab32f4ee04e28399a89eaa89b35.png";